/* template */
<template><div class="cate-in-list"><span class="cate-text">{{ cateName }}</span></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m57520d6c"}'>
.cate-in-list
  display flex
  flex-flow row nowrap
  justify-content center
  align-items center
  &:before, &:after
    content ''
    display block
    width 75rpx
    height 1px
    background-color #979797
    opacity .23
  .cate-text
    font-size 24rpx
    color #888888
    margin 18rpx 24rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'

createComponent({
  name: 'CateInList',
  properties: {
    cateName: {
      type: String,
      value: '',
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "cate_in_list57520d6c",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
